import React from "react"
import { Button } from 'primereact/button';
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Callbacks } from "jquery";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList } from "../../entities/Constants";


interface Props {
    section: FormSections;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogForAPIComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={"Set up API for section " +  this.props.section.ENUTitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];

        htmlString.push(
            <div >
                {/* <div><InputText className="ontario-input" style={{marginBottom:'10px'}} placeholder="Please type in Section's Entity Name" value={this.props.section.EntityName} onChange={(e) => {
                    this.props.section.EntityName = e.target.value;
                    this.props.callback();
                }}></InputText></div> */}
                <div><InputText className="ontario-input" style={{marginBottom:'10px'}} placeholder="Please type in Get API name" value={this.props.section.GetAPI} onChange={(e) => {
                    this.props.section.GetAPI = e.target.value;
                    this.props.callback();
                }}></InputText></div>
                <div> <InputText className="ontario-input"  style={{marginBottom:'10px'}}  placeholder="Please type in your Update API name" value={this.props.section.UpdateAPI} onChange={(e) => {
                    this.props.section.UpdateAPI=e.target.value;
                    this.props.callback();
                }}></InputText></div>
                 <div><InputText className="ontario-input"  style={{marginBottom:'10px'}}  placeholder="Please type in your Delete API name" value={this.props.section.DeleteAPI} onChange={(e) => { 
                    this.props.section.DeleteAPI=e.target.value;
                    this.props.callback();
                }}></InputText></div>
            </div> 
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
